export interface ErrorObject {
  code?: string
  type?: string
  msg?: string
}

/** @public */
export enum GoogleTagCategory {
  Error = 'Error',
  Warning = 'Warning',
  Info = 'Info',
  Time = 'Time',
}
